import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-stepper',
  templateUrl: './app-stepper.component.html',
  styleUrl: './app-stepper.component.scss',
})
export class AppStepperComponent {
  @Input() steps: number = 0;
  @Output() nextStep: EventEmitter<number> = new EventEmitter();
  @Output() prevStep: EventEmitter<number> = new EventEmitter();
  @Input() currentStep: number = 0;

  next() {
    if (this.currentStep < this.steps - 1) {
      this.currentStep++;
      this.nextStep.emit(this.currentStep);
    }
  }

  prev() {
    if (this.currentStep > 0) {
      this.currentStep--;
      this.prevStep.emit(this.currentStep);
    }
  }

  get stepsArray(): number[] {
    return Array.from({ length: this.steps }, (_, i) => i);
  }
}
